import { TableCell, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTableCell = styled((props) => <TableCell {...props} />)`
  font-size: 12px;
  font-weight: bold;
  border: 0;
  color: ${({ disabled, theme }) =>
    disabled ? theme.palette.text.disabled : theme.palette.text.main};
  
  /* Responsive text handling */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  /* Ensure minimum width for all columns */
  min-width: 60px;
  
  @media (max-width: 768px) {
    /* Better mobile experience */
    font-size: 11px;
    padding: 6px 4px;
    white-space: normal;
    word-break: break-word;
    min-width: 50px;
  }
  
  @media (max-width: 480px) {
    /* Very small screens */
    font-size: 10px;
    padding: 4px 2px;
    min-width: 40px;
  }
`;
export const StyledTableHeaderCell = styled((props) => (
  <TableCell {...props} />
))`
  border-color: ${({ theme }) => theme.palette.primary.main};
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.text.secondary};
  padding: 8px;
  
  @media (max-width: 768px) {
    font-size: 11px;
    padding: 6px 4px;
  }
  
  @media (max-width: 480px) {
    font-size: 10px;
    padding: 4px 2px;
  }
`;

export const StyledTableRow = styled((props) => <TableRow {...props} />)`
  &:last-child td,
  &:last-child th {
    border: 0;
  }

  ${({ withborders }) =>
    withborders &&
    `
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  `}
`;